import { Tabs } from "@radix-ui/themes"

type TabContentProps = {
  children: JSX.Element
  name: string
  ident: string
  className?: string
}
export const TabContent = ({ children, ident, className }: TabContentProps) => {
  return (
    <Tabs.Content value={ident} className={`${className || ""}`}>
      {children}
    </Tabs.Content>
  )
}
